<script setup>
import {defineProps, ref} from 'vue';

const {
  service,
  servicefiles
} = defineProps(['service', 'servicefiles']);

</script>

<style>
#projectTable tr th, #projectTable tr td {
  padding: .5rem;
}
</style>

<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">


        <div class="widget-heading pb-0 d-block">
          <div class="row">
            <div class="col-md-12 col-lg-10 d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h4 class="d-inline-block h4 me-4" style="line-height: 1.4">
                  Zgłoszenie: <b>{{ service.number }}</b>
                </h4>
                <span class="text-danger font-weight-bolder" v-if="service.archived">ZARCHIWIZOWANE</span>
              </div>
              <div class="ms-4">
                <Link :href="route('service.index')" class="btn btn-outline-primary">
                  <i class="bi bi-list"></i>&nbsp;Lista zgłoszeń
                </Link>
              </div>
            </div>
            <div class="col-md-12 col-lg-2 text-end">
              <form id="deleteServiceForm" class="d-inline-block me-2" method="post" @submit.prevent="deleteService">
                <input type="hidden" name="_token" :value="csrfToken">
                <button v-if="hasPermission('canDelService')" class="btn btn-outline-danger">Usuń zgłoszenie</button>
              </form>
            </div>
          </div>


          <div class="row">
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitHideOnList" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="serviceHideOnList" type="checkbox" class="custom-control-input"
                         :checked="service.hide_on_list" @change="changeServiceHideOnList">
                  <label for="serviceHideOnList" class="custom-control-label h6">Nie pokazuj na liście zgłoszeń</label>
                </div>
                <button v-if="hideOnListServiceHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitArchived" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="servicearchived" type="checkbox" class="custom-control-input"
                         :checked="service.archived" @change="changeServiceArchived">
                  <label for="servicearchived" class="custom-control-label h6">Archiwizuj zgłoszenie</label>
                </div>
                <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
          </div>
          <serviceMenu :service="service"></serviceMenu>

        </div>


        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="row mt-2 ms-0 me-0">
                <h4 class="me-3 my-0 mb-3">Pliki protokołu:</h4>
                <div class="row">
                  <ul class="list-group ps-3 me-3 mt-3 mb-3">
                    <li class="list-group-item fw-bold bg-light d-none d-sm-block" v-if="localServiceFiles.length > 0">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-5">Nazwa pliku</div>
                        <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                        <div class="col-12 col-sm-2 col-md-3 text-end">Opcje</div>
                      </div>
                    </li>
                    <li v-if="isLoadingFiles" class="list-group-item border-0 text-center">
                      <div class="spinner-border spinner-border-reverse loader-sm text-secondary" role="status">
                        <span class="visually-hidden">Ładowanie...</span>
                      </div>
                    </li>
                    <li v-else v-for="file in localServiceFiles" :key="file.name" class="list-group-item">
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-6 col-md-5 text-break fw-bold">{{ file.name }}</div>
                        <div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ file.created_at }}</i></div>
                        <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                          <div class="d-inline-flex flex-wrap gap-2">
                            <a class="btn btn-sm btn-outline-info"
                               :href="route('services.download-protocol-file', [service.id, file.name])" download><i
                                class="bi bi-download me-1"></i>Pobierz</a>
                            <button v-if="hasPermission('canEditService')" class="btn btn-sm btn-outline-danger"
                                    @click="deleteFile(file)" type="button"><i class="bi bi-trash me-1"></i>Usuń
                            </button>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item text-center" v-if="localServiceFiles.length <= 0 && !isLoadingFiles"><i>Brak
                      plików</i></li>
                  </ul>
                </div>

                <form @submit.prevent="submitForm">
                  <div v-if="hasPermission('canEditService')" class="row gap-3">
                    <div class="col-12 col-md-6">
                      <label for="attachments">Dodaj pliki:</label>
                      <div v-if="isLoading" class="mt-3">
                        <div class="progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                               :style="{ width: uploadProgress + '%' }"></div>
                        </div>
                        <small class="text-muted">{{ uploadProgress }}%</small>
                      </div>
                      <input type="file" id="attachments" multiple @change="handleFileUpload"
                             class="form-control form-control-sm" ref="fileInput"/>
                      <div v-if="form.attachments.length">
                        <p class="mt-2">Załączone pliki:</p>
                        <ul class="list-group">
                          <li class="list-group-item d-flex justify-content-between align-items-center"
                              v-for="(file, index) in form.attachments" :key="index">
                            {{ file.name }}
                            <button type="button" class="btn btn-sm btn-danger" @click="removeFile(index)">Usuń</button>
                          </li>
                        </ul>
                      </div>
                      <div v-if="form.attachments.length">
                        <template v-if="!isLoading">
                          <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading"
                                  v-if="hasPermission('canEditService')">
                            {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
                          </button>
                        </template>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {defineProps, ref} from "vue";
import {useForm} from "@inertiajs/vue3";

import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {router} from "@inertiajs/vue3";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import serviceMenu from "@/Pages/Service/serviceMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, serviceMenu},


  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({})
    },
    servicefiles: {
      type: Array,
      required: true,
      default: () => []
    },
  }
  ,
  data() {
    return {
      initAttachments: [],
      isProcessing: false,
      isLoadingFiles: false,
      localServiceFiles: [...this.servicefiles],
      hideOnListForm: useForm({
        hide_on_list: this.service.hide_on_list || false
      }),
      hideOnListServiceHasChanged: false,
      archiveOnListForm: useForm({
        archived: this.service.archived || false
      }),
      archivedHasChanged: false,
      isLoading: false,
      hasPermission,
      uploadProgress: 0,
      uploadError: null,
      uploadSuccess: false,
      form: {
        name: null,
        attachments: [],
        errors: {}
      },
    };
  },

  async mounted() {
    this.isLoadingFiles = true;
    this.initAttachments = await this.getProtocolAttachments();
    this.matchFiles();
    this.isLoadingFiles = false;

  },
  methods: {
    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },
    async getProtocolAttachments() {
      try {
        const response = await axios.post(route('services.get.protocolattachments', {service: this.service.id}));
        return response.data.attachments ?? [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    handleFileUpload(event) {
      this.uploadError = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFiles = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadError = `Plik "${file.name}" jest pusty.`;
        } else {
          validFiles.push(file);
        }
      }

      if (validFiles.length > 0) {
        this.form.attachments.push(...validFiles);
      }

      this.$refs.fileInput.value = "";
    },
	
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },

    matchFiles() {
      try {
        if (this.initAttachments.length > 0) {
          this.localServiceFiles = [...this.initAttachments];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async refreshAttachments() {
      this.isLoadingFiles = true;
      try {
        const attachments = await this.getProtocolAttachments();
        this.localServiceFiles = attachments;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async submitForm() {
      this.form.errors = {};
      this.uploadError = null;
      this.uploadProgress = 0;
      this.isLoading = true;
      this.isProcessing = true;

      if (this.form.attachments.length === 0) {
        this.uploadError = "Nie wybrano plików do wysłania.";
        this.isLoading = false;
        this.isProcessing = false;
        return;
      }

      let formData = new FormData();
      this.form.attachments.forEach(file => formData.append('attachments[]', file));

      try {
        const response = await axios.post(
            route('service.storeProtocolFile', {id: this.service.id}),
            formData,
            {
              headers: {'Content-Type': 'multipart/form-data'},
              onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                  this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                }
              }
            }
        );

        this.form.attachments = [];
        this.$refs.fileInput.value = "";
        this.uploadProgress = 100;
        await this.refreshAttachments();

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
      } finally {
        this.isLoading = false;
        this.isProcessing = false;
        setTimeout(() => this.uploadProgress = 0, 2000);
      }
    },

    changeServiceHideOnList() {
      this.hideOnListForm.hide_on_list = event.target.checked;
      this.hideOnListServiceHasChanged = true;
    },

    changeServiceArchived() {
      this.archiveOnListForm.archived = event.target.checked;
      this.archivedHasChanged = true;
    },

    submitHideOnList() {
      axios.post(route('service.updateHideOnList', {service: this.service.id}), {
        hide_on_list: this.hideOnListForm.hide_on_list
      })
          .then(() => {
            this.hideOnListServiceHasChanged = false;
            this.showToast('success', 'Sukces', 'Status ukrycia na liście został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },

    submitArchived() {
      axios.post(route('service.updateArchived', {service: this.service.id}), {
        archived: this.archiveOnListForm.archived
      })
          .then(() => {
            this.archivedHasChanged = false;
            this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },
    deleteService(event) {
      const self = this;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie zgłoszenia',
        html: '<strong>Czy na pewno chcesz usunąć to zgłoszenie?</strong><br>Tej operacji nie można cofnąć!',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        position: 'center',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('service.destroy', this.service.id), {
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
          }).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Zgłoszenie usunięte',
              html: '<strong>Zgłoszenie zostało pomyślnie usunięte.</strong><br>Za chwilę nastąpi przekierowanie...',
              timer: 3000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              self.$inertia.visit(route('service.index'));
            }, 3000);
          }).catch(error => {
            console.error('Błąd usuwania:', error);
            Toast.fire({
              icon: 'error',
              title: 'Błąd usuwania',
              html: '<strong>Nie udało się usunąć zgłoszenia.</strong><br>Spróbuj ponownie później.',
            });
          });
        }
      });
    },

    deleteFile(file) {
      let self = this;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('services.file.deleteProtocol', {
            service: self.service.id,
            attachment: file.id
          }))
              .then(response => {
                self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
                self.refreshAttachments();
              })
              .catch(error => {
                console.error("Błąd usuwania pliku:", error);
                self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
              });
        }
      });
    },

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};

</script>


<style scoped>
.tooltip {
  opacity: 1 !important;
}
</style>
